export const unimarcFields = `
id
slug
title
status
type
authors {
  firstName
  lastName
}
isbn
publisher
collation
collections
collectivities
works
subjects
tracks
tracksSlug{
title
slug
trackTitle
trackSlug
}
subject
resume
photo {
  getUrl
}
descriptor
index
statuses {
  code
  site
  display
  dueDate: due_date
  callNumber: call_number
  type
}
`
export const getBookBySlug = () => {
  return `query getBookBySlug($slug: String!) {
  unimarcBySlug(slug: $slug) {
    ${unimarcFields}
      }
  }`
}

export const getSubjects = () => {
  return `query getSubjects {
  unimarcSubjects
  }`
}

export const updateBook = () => {
  return `mutation updateUnimarc (
        $slug:String!
        $status: String!
    ) {
        updateUnimarc(
            slug:$slug,
            unimarc:{
            status:$status
            }
        ){
            slug,
            status,
        }
    }`
}
